import { Result } from '@mapbox/mapbox-gl-geocoder';
import Axios, { AxiosResponse } from 'axios';
import qs from 'qs';

import ApiEndpoint from './apiEndpoint';

export const mapAccessKeys = {
  // Thanks to SomeSoftwareTeam (https://github.com/SomeSoftwareTeam/some-react-app/blob/acd17860b8b1f51edefa4e18486cc1fb07afff70/src/components/SomeComponent.js)
  // mapboxApiAccessToken: 'pk.eyJ1Ijoiam9uc2VuIiwiYSI6IkR6UU9oMDQifQ.dymRIgqv-UV6oz0-HCFx1w',
  mapboxApiAccessToken2: 'pk.eyJ1IjoiZnIwc3RmMHgiLCJhIjoiY2tuNWlwMzd5MDRsbzJ3cmc4MzhpaHEzMiJ9.nnFWUkuEEQaNfuXtXwjU1w',
};

const requestConfig = {
  accessToken: mapAccessKeys.mapboxApiAccessToken2,
  countries: 'us',
  types: 'address,place,poi',
};

export default class MapService {
  static getMapSuggestion(text: string): Promise<AxiosResponse<{ features: Result[] }>> {
    return Axios.get<{ features: Result[] }, AxiosResponse<{ features: Result[] }>>(
      `${ApiEndpoint.mapboxSearch}${encodeURIComponent(text)}.json?${qs.stringify({
        country: requestConfig.countries,
        limit: 5,
        types: requestConfig.types,
        language: 'en-US',
        access_token: requestConfig.accessToken,
      })}`,
    );
  }

  static getMapPlusCodeFromCoordinate(
    coordinate: number[],
  ): Promise<AxiosResponse<{ plus_code: { global_code: string } }>> {
    return Axios.post<{ plus_code: { global_code: string } }, AxiosResponse<{ plus_code: { global_code: string } }>>(
      ApiEndpoint.plusCodeConverter,
      null,
      {
        params: {
          address: coordinate.join(','),
        },
      },
    );
  }
}
